// src/service/ClientService.ts
import axiosClient from "./axiosClient";
import { IClientDTO } from "@interfaces/IClientDTO";

const ClientService = {
  getAllClients: async (): Promise<IClientDTO[]> => {
    try {
      const response = await axiosClient.get("/client_api/clients_list");
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error("Error fetching clients:", error);
      throw error;
    }
  },

  getClientById: async (id: number): Promise<IClientDTO | null> => {
    try {
      const response = await axiosClient.get(`/client_api/client/${id}`);
      return response.data || null;
    } catch (error) {
      console.error(`Error fetching client ${id}:`, error);
      throw error;
    }
  },

  createClient: async (data: Partial<IClientDTO>): Promise<IClientDTO> => {
    const response = await axiosClient.post("/client_api/create", data);
    return response.data;
  },

  updateClient: async (data: Partial<IClientDTO>): Promise<IClientDTO> => {
    const response = await axiosClient.post("/client_api/update", data);
    return response.data;
  },

  deleteClient: async (id: number): Promise<void> => {
    await axiosClient.delete(`/client_api/delete/${id}`);
  },
};

export default ClientService;
